import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f09ff9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "edit-queue-modal-wrapper" }
const _hoisted_2 = { class: "edit-queue-modal-wrapper_tabs" }
const _hoisted_3 = { class: "edit-queue-modal-wrapper_tabs_item__icon" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "edit-queue-modal-wrapper_tabs_item__content" }, "Основная информация", -1))
const _hoisted_5 = { class: "edit-queue-modal-wrapper_tabs_item__icon" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "edit-queue-modal-wrapper_tabs_item__content" }, "Сотрудники", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "edit-queue-modal-wrapper_tabs_item__icon" }, [
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "edit-queue-modal-wrapper_tabs_item__content" }, "Статусы", -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "edit-queue-modal-wrapper_tabs_item__icon" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "edit-queue-modal-wrapper_tabs_item__content" }, "Приоритеты", -1))
const _hoisted_12 = { class: "edit-queue-modal-wrapper_slot" }

import { PropType } from "vue";
import { EditQueueEnum } from "../enums";
import { Cog6ToothIcon, UserGroupIcon } from "tir-style-system/icons/outline";
import { FlagIcon } from "tir-style-system/icons/solid";
/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'edit-queue-modal-wrapper',
  props: {
  /**Текущий таб */
  tab: { type: String as PropType<EditQueueEnum> },
},
  emits: ["update:tab"],
  setup(__props, { emit }) {

const props = __props;


/**События */


/**Выбор таба */
const setTab = (tab: EditQueueEnum) => emit("update:tab", tab);
/**Проверить активен ли таб */
const getTabClass = (_tab: EditQueueEnum) => [
  "edit-queue-modal-wrapper_tabs_item",
  { active: props.tab == _tab },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(getTabClass(_unref(EditQueueEnum).Main)),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (setTab(_unref(EditQueueEnum).Main)))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(Cog6ToothIcon))
        ]),
        _hoisted_4
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(getTabClass(_unref(EditQueueEnum).Employees)),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (setTab(_unref(EditQueueEnum).Employees)))
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(UserGroupIcon))
        ]),
        _hoisted_6
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(getTabClass(_unref(EditQueueEnum).Statuses)),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (setTab(_unref(EditQueueEnum).Statuses)))
      }, _hoisted_9, 2),
      _createElementVNode("div", {
        class: _normalizeClass(getTabClass(_unref(EditQueueEnum).Priorities)),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (setTab(_unref(EditQueueEnum).Priorities)))
      }, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_unref(FlagIcon))
        ]),
        _hoisted_11
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})